define.alias("shared/components/shared/modal/section", "calendar/components/shared/modal/section");